module.exports = __webpack_public_path__ + "static/media/pdficon.cccf2da2.svg";